// Firebase client singletons for clubmanager-pwa. Project config + env live in
// `./config`; the actual client construction (persistent multi-tab cache,
// europe-west1 functions region, in-memory fallback) is the shared
// `@upadelmatch/core` factory, so usersmatch-pwa builds its client the same
// way from its own project config. Call sites keep importing
// `@/core/firebase/client` unchanged.
import { createFirebaseClient } from '@upadelmatch/core/firebase-client'
import { firebaseConfig, env } from './config'

const client = createFirebaseClient(firebaseConfig)

export const app = client.app
export const auth = client.auth
export const db = client.db
export const functions = client.functions
export { env }
